var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        position: "fixed",
        right: "1rem",
        bottom: "2rem",
        display: "flex",
        "flex-direction": "column",
        "justify-content": "end",
        "align-items": "end",
        "z-index": "1000",
      },
    },
    _vm._l(_vm.tags, function (item, index) {
      return _c("div", { key: index, staticClass: "btn-group mb-2" }, [
        item.isTag == true
          ? _c(
              "button",
              {
                staticClass: "btn btn-success rounded-pill btn-h w-auto",
                staticStyle: { "padding-right": "36px" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.PRINT_TAG(item.id, index)
                  },
                },
              },
              [
                _vm.loadings.filter(function (e) {
                  return e == index
                }).length == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "spinner-border spinner-border-sm mb-0",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    )
                  : _c("div", { staticClass: "d-flex" }, [
                      _c("i", { staticClass: "bi bi-printer mr-2" }),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          'Imprimir TAG "' +
                            _vm._s(item.type) +
                            _vm._s(item.id) +
                            '"'
                        ),
                      ]),
                    ]),
              ]
            )
          : _c(
              "a",
              {
                staticClass: "btn rounded-pill btn-h w-auto",
                class:
                  typeof item.error == "boolean" && item.error == true
                    ? "bg-soft-danger text-danger disabled"
                    : item.class,
                staticStyle: { "padding-right": "36px" },
                attrs: { href: item.href, target: "_blank" },
              },
              [
                _c(
                  "v-tooltip",
                  {
                    staticClass: "mx-1",
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "div",
                                _vm._g(
                                  _vm._b(
                                    { staticClass: "nowrap" },
                                    "div",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  typeof item.error == "boolean" &&
                                  item.error == true
                                    ? _c("div", { staticClass: "d-flex" }, [
                                        _c("i", {
                                          staticClass:
                                            "mr-2 bi bi-exclamation-circle",
                                        }),
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(item.title) +
                                            "\n                        "
                                        ),
                                      ])
                                    : _c("div", [
                                        !item.href ||
                                        typeof item.href == "undefined"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "spinner-border spinner-border-sm mb-0",
                                                attrs: { role: "status" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("Loading...")]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c("i", {
                                                  staticClass: "mr-2",
                                                  class: item.icon,
                                                }),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(item.title) +
                                                    "\n                            "
                                                ),
                                              ]
                                            ),
                                      ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("small", [_c("div", [_vm._v(_vm._s(item.title))])]),
                  ]
                ),
              ],
              1
            ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-light rounded-pill btn-m position-absolute",
            class:
              typeof item.error == "boolean" && item.error == true
                ? "text-danger border-danger"
                : "text-success border-success",
            staticStyle: { right: "0", "z-index": "1" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$store.dispatch("REMOVE_TAGS", index)
              },
            },
          },
          [_c("i", { staticClass: "bi bi-x" })]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }